var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_154","data-name":"Group 154","transform":"translate(-1315.621 -152.066)"},[React.createElement("line",{"id":"Line_21","data-name":"Line 21","x1":"26","y2":"26","transform":"translate(1318.449 154.894)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"4","key":0}),React.createElement("path",{"id":"Path_52","data-name":"Path 52","d":"M0,0,26,26","transform":"translate(1318.449 154.894)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"4","key":1})]));
}

Close.defaultProps = {"width":"31.657","height":"31.657","viewBox":"0 0 31.657 31.657"};

module.exports = Close;

Close.default = Close;
